
export default class CodeStorage {
  static language = 'logic'

  static logic = "\n// Use [LogicBoard] for custom connections\n"
  static ts = "\n// Click [RUN] to compile project\n"
  static js = "\n// Click [RUN] to compile project\n"
}
